export default {
  chooseChannel: {
    text1: 'How did you hear about GitTap?',
    text2: ''
  },
  channelNone: 'None'
}
